import React, { useEffect, useRef, useState } from 'react';

const LazyRenderWrapper = ({
  children,
  component: Component = 'div',
  options,
  noVisibleHeight = 200
}) => {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const { isIntersecting } = entry;
        if (isIntersecting) {
          setLoaded(true);
          observer.disconnect();
        } else {
          setLoaded(false);
        }
      });
    }, options);

    observer.observe(ref.current);
  }, [options]);

  if (loaded) {
    return <Component ref={ref}>{children}</Component>;
  }

  return <Component style={{ height: `${noVisibleHeight}px` }} ref={ref} />;
};

export default LazyRenderWrapper;
